module.exports = __webpack_public_path__ + "static/media/Tawuniya-Medium.bc4c45f4.otf";